import { jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
import { isLocaleRTL } from "./isLocaleRTL";
const defaultLocale = {
  direction: "ltr",
  locale: "en-US"
};
const LocaleContext = createContext(defaultLocale);
function getLocaleDirection(locale) {
  return isLocaleRTL(locale) ? "rtl" : "ltr";
}
function LocaleProvider(props) {
  const { direction, locale, children } = props;
  const needsContext = direction || locale;
  return needsContext ? /* @__PURE__ */ jsx(
    LocaleContext.Provider,
    {
      value: {
        direction: locale ? getLocaleDirection(locale) : direction,
        locale
      },
      children
    }
  ) : children;
}
function useLocaleContext() {
  return useContext(LocaleContext);
}
export {
  LocaleProvider,
  getLocaleDirection,
  useLocaleContext
};
//# sourceMappingURL=index.js.map
